













































import DesignLayoutForm from "@/components/layout_wizard/DesignLayout.vue";
import SaveLayoutForm from "@/components/layout_wizard/SaveLayoutForm.vue";
import UploadFileForm from "@/components/layout_wizard/UploadFileForm.vue";
import { $store } from "@/store";
import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "ag-upload-file-form": UploadFileForm,
    "ag-design-layout-form": DesignLayoutForm,
    "ag-save-layout-form": SaveLayoutForm,
  },
})
export default class LayoutWizardView extends Vue {
  get currentStep() {
    return $store.wizard.layoutStep;
  }

  set currentStep(val) {
    $store.wizard.layoutStep = val;
  }

  get showUploadStep() {
    return !$store.wizardInstances.wizardInstance?.config.layout?.layoutSource;
  }

  get wizardInstance() {
    return $store.wizardInstances.wizardInstance;
  }

  mounted() {
    /**
     * Adds predefined inserts in wizard instance to current layout
     */
    const predefinedInserts =
      this.wizardInstance?.config.layout?.predefinedInserts;
    if (predefinedInserts && Array.isArray(predefinedInserts)) {
      predefinedInserts.forEach((insert) => {
        const [idx] = $store.layouts.addInsert(insert.page || 1, insert.type);
        $store.layouts.updateInsert(idx, insert);
      });
      $store.layouts.layoutName = this.wizardInstance?.id as string;
    }
  }
}
